import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=52dda578&scoped=true"
import script from "./teacherList.vue?vue&type=script&lang=js"
export * from "./teacherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dda578",
  null
  
)

export default component.exports